import React, {
  useContext,
  useState,
  useCallback,
  useMemo,
  useRef,
} from 'react'
import { strCol, intCol, dateTimeCol } from '@integec/grid-tools/lib/cols'
import {
  modifierCol,
  modifiedDateCol,
  utilityReqHeader,
  unitHeader,
} from 'core/HeaderColTypeProps'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import R from 'ramda'

import {
  getEventBreakerData,
  multipleSaveByPiBreakerVerifyService,
} from './getServiceUtil'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getUtilityUnitsMap,
  getCauseCodeMap,
  getUnits,
  getFailCode,
  getAmlificationCode,
  getPermitActions,
  getEnvConfig,
  getEventTypes,
  getCauseCodeOmcMap,
} from 'core/selectors'
import {
  Button,
  // Input,
  message,
  Select,
  DatePicker,
  InputNumber,
  Divider,
  Switch,
} from 'antd'

import CardsErrorDialog from './CardErrorDialogAntd'
import { SpinContext, ErrorContext } from 'context'
import {
  CriteriaRow,
  Title,
  Content,
  FullHeightSizer,
  Label,
  Filler,
} from 'core/screen-util'
import Grid, {
  virtualizedGridRenderer,
  defaultVirtualizedCellRender,
  VirtualizedCell,
  extractAndFormatData,
} from '@integec/grid-tools'
import { hasAccesPermits, rowHeaderRender } from 'core/utils'
import moment from 'moment'
import * as ScreenPermissions from 'core/EventActions'

// import { updateCurrentCardDataAfterSave } from './utils'
// import DomNucExtension from './component/card97/DukeNucExtension'
import UtilityUnitSelection from 'core/component/UtilityUnitSelection'
// import JcTmpErrorContext from '../context/JcTmpErrorContext'
import { isErrorContainsTmpError } from '../core/component/JcTmpErrorDialog'

export const headers = [
  unitHeader,
  intCol({ ident: 'year', display: 'Year', isKey: true, width: 50 }),
  intCol({
    ident: 'eventNum',
    display: 'Event Number',
    isKey: true,
    width: 60,
  }),
  intCol({ ident: 'eventIdx', display: 'Event Index', isKey: true, width: 60 }),
  strCol({
    ident: 'eventType',
    display: 'Event Type',
    isKey: true,
    isFiltered: true,
    width: 60,
  }),
  utilityReqHeader,
  dateTimeCol({
    ident: 'eventStart',
    display: 'Event Start Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'eventEnd',
    display: 'Event End Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  strCol({ ident: 'availCap', display: 'Available Capacity' }),
  intCol({ ident: 'causeCode', display: 'Cause Code', isFiltered: true }),
  strCol({
    ident: 'causeCodeDescription',
    display: 'Cause Code Description',
    isFiltered: true,
    alignment: 'left',
    ellipsis: true,
    width: 250,
    // dataGetter: ({ rowData }) => causeCodeMap[rowData.causeCode],
  }),
  strCol({ ident: 'conCode', display: 'Contribution Code', width: 200 }),
  strCol({
    ident: 'eventTypeExternal',
    display: 'Contributing Operating Condition',
    isFiltered: true,
    width: 350,
    alignment: 'left',
    ellipsis: true,
  }),
  strCol({ ident: 'ioCode', display: 'Dominant' }),
  dateTimeCol({
    ident: 'workStart',
    display: 'Work Start Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'workEnd',
    display: 'Work End Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  intCol({ ident: 'manHour', display: 'Man Hours' }),
  strCol({ ident: 'failCode', display: 'Fail Code', isFiltered: true }),
  strCol({ ident: 'ampCode', display: 'Amplification Code', isFiltered: true }),
  strCol({
    ident: 'description',
    display: 'Description',
    width: 2000,
    alignment: 'left',
    ellipsis: true,
  }),

  modifierCol,
  modifiedDateCol,
  // strCol({ ident: 'lock', display: 'Lock' }),
].map(e => ({ ...e, isFiltered: true }))

export const timeZoneList = R.compose(
  R.fromPairs,
  R.map(a => [`${a.utility}${a.unit}`, a.timeZone])
)
export const unitCodeList = R.compose(
  R.fromPairs,
  R.map(a => [`${a.utility}${a.unit}`, a.id1])
)
export const unitShortNameList = R.compose(
  R.fromPairs,
  R.map(a => [`${a.utility}${a.unit}`, a.shortName])
)

const title = 'Breaker & Event - Verification'

const Card97 = ({
  utilityNameMap,
  unitNameMap,
  // utilityUnitMap,

  apiTargetInfo,

  envConfig,
  //  units,
  causeCodeOmcMap,
  ...props
}) => {
  // eslint-disable-next-line no-unused-vars
  const [isRetrieve, setISRetrieve] = useState(false)
  const CLIENT = envConfig.clientId || 'INTEG'
  const { setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  // const { setJcErrors } = useContext(JcTmpErrorContext)
  const [data, setData] = useState([])
  // eslint-disable-next-line no-unused-vars
  const [eventData, setEvemtData] = useState([])

  // const [loading, setLoading] = useState(false)

  const [errorSaveData, setErrorSaveData] = useState([])
  //  const [err, setError] = useState(null)
  // const [selectedRows, setSelectedRows] = useState([])
  const [breakerRowSelected, setBreakerRowSelected] = useState([])

  // const { selectedUnits, setVisibleUnitSelection } = useContext(
  //   UnitSelectionContext
  // )
  // const { setSelectedDate, selectedDate } = useContext(DatePickerContext)
  const [selectedDate, setSelectedDate] = useState(
    moment('2025-09-01').startOf('d')
  )

  const setErr = useCallback(
    err => {
      setError(err)
      setSpinning(false)
      setData([])
      setEvemtData([])
    },
    [setError, setSpinning]
  )

  const selectionChange = selected => {
    const selc = selected.selectedRows
    setBreakerRowSelected(selc)

    // setSelectedAll(selected)
  }

  const [minuteGap, setMinuteGap] = useState(10)

  const onRetrieveDataEvent = _ => {
    if (!minuteGap || minuteGap <= 0 || (minuteGap + '').trim().length <= 0) {
      message.error('Please enter valid Minute Gap value.')
      return
    }
    setSpinning(true)
    getEventBreakerData(apiTargetInfo)({
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
      unitid: selectedUnitId,
      withCrow: 'Y',
      minuteGap: minuteGap,
    }).fork(setErr, data => {
      setSpinning(false)
      setISRetrieve(true)
      const { card97, eventBreaker } = data

      const bwl = eventBreaker.map(e => {
        const found = card97.find(
          c =>
            c.year === e.year &&
            c.unit === e.unit &&
            c.utility === e.utility &&
            c.eventNum === e.eventNum &&
            c.eventIdx === '1'
        )

        return {
          ...e,
          lock: found?.lock,
          causeCode: found?.causeCode,
          availCap: found?.availCap,
        }
      })

      setData(bwl)
      setEvemtData(card97)
    })
  }

  const onUpdate = _ => {
    const updatedBreakerEventforUpdate = breakerRowSelected.map(d => {
      let selectedEventRows = { ...d }
      if (selectionTypeChnage === 'START') {
        selectedEventRows = {
          ...selectedEventRows,
          eventStart: selectedEventRows.breakerStart,
        }
      } else if (selectionTypeChnage === 'END') {
        selectedEventRows = {
          ...selectedEventRows,
          eventEnd: selectedEventRows.breakerEnd,
        }
      } else {
        // both

        selectedEventRows = {
          ...selectedEventRows,
          eventStart: selectedEventRows.breakerStart,
          eventEnd: selectedEventRows.breakerEnd,
        }
      }
      return selectedEventRows
    })

    setSpinning(true)

    if (updatedBreakerEventforUpdate.length <= 0) {
      message.loading('No data selected to update.')
      return
    }

    multipleSaveByPiBreakerVerifyService(
      apiTargetInfo,
      CLIENT
    )(updatedBreakerEventforUpdate).fork(setError, tmpErrors => {
      setSpinning(false)
      setErrorSaveData(tmpErrors)

      if (!isErrorContainsTmpError(tmpErrors)) {
        message.success('Data saved successfully.')
        onRetrieveDataEvent()
      }
    })
  }

  // const [fuzzyFilter, setFuzzyFilter] = useState('')

  const headerWithFormatter = useMemo(
    _ =>
      Headers.map(header =>
        header.ident === 'utility'
          ? {
              ...header,

              dataFormatter: ({ value }) =>
                utilityNameMap[value]
                  ? value + ' - ' + utilityNameMap[value]
                  : value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : header.ident === 'unit'
          ? {
              ...header,
              // choices: [],
              dataFormatter: ({ value }) =>
                unitNameMap[value]
                  ? value.substr(3) + ' - ' + unitNameMap[value]
                  : value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unit] || rowData.unit,
            }
          : header
      ),
    [utilityNameMap, unitNameMap]
  )

  const GridRef = useRef()

  const [selectedUnitId, setSelectedUnitId] = useState('999999')
  const [selectionTypeChnage, setSelectionTypeChange] = useState('BOTH')

  const [showAll, setShowAll] = useState(false)

  const finalDAta = useMemo(
    _ => {
      if (showAll) {
        return data
      } else {
        return data.filter(d => {
          const { eventStart, eventEnd, breakerEnd, breakerStart } = d
          return eventStart !== breakerStart || eventEnd !== breakerEnd
        })
      }
    },
    [showAll, data]
  )

  const card97Admin = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits: props.actionPermits,
        eventActions: [ScreenPermissions.CARD97_ADMIN],
        matchAny: true,
      }),
    [props.actionPermits]
  )

  return (
    <React.Fragment>
      <div
        style={{
          backgroundColor: '#f0f2f5',
          marginLeft: '20px',
          marginRight: '20px',
        }}
      >
        <CriteriaRow
          style={{
            display: 'grid',
            gridTemplateColumns:
              '300px 400px 150px 100px 150px 150px 120px auto 10px 150px 150px',
            gap: '10px',
            overflowX: 'auto',
          }}
        >
          <Title>{title}</Title>
          <UtilityUnitSelection
            className="utilityUnit"
            utility={selectedUnitId.substring(0, 3)}
            unit={selectedUnitId}
            onUnitChange={value => {
              setSelectedUnitId(value[1])
            }}
            casStyle={{ width: '100%' }}
          />
          <DatePicker.MonthPicker
            onChange={date => {
              setSelectedDate(date.clone().startOf('d'))
            }}
            value={selectedDate}
            format="MMMM-YYYY"
          />
          <Label style={{ alignSelf: 'center' }}>Minute Gap:</Label>
          <InputNumber
            value={minuteGap}
            onChange={value => setMinuteGap(value)}
            style={{ width: '100%' }}
            min={1}
            // max={60}
          />
          <Button
            style={{}}
            onClick={onRetrieveDataEvent}
            type="primary"
            icon="database"
          >
            Retrieve
          </Button>
          <Switch
            checked={showAll}
            onChange={setShowAll}
            checkedChildren="Show All"
            unCheckedChildren="Hide Match Data"
          />
          <Filler />
          <Divider type="vertical" style={{ height: '100%' }} />
          {card97Admin && (
            <Select
              defaultValue="BOTH"
              style={{}}
              onChange={e => setSelectionTypeChange(e)}
              value={selectionTypeChnage}
            >
              <Select.Option value="START">Start Date</Select.Option>
              <Select.Option value="END">End Date</Select.Option>
              <Select.Option value="BOTH">Start-End Date</Select.Option>
            </Select>
          )}
          {card97Admin && (
            <Button
              onClick={onUpdate}
              disabled={!breakerRowSelected}
              style={{}}
              icon="edit"
              type="danger"
            >
              Update
            </Button>
          )}
          {/* <Input.Search
            placeholder="Filter"
            value={fuzzyFilter}
            style={{
              gridColumnEnd: 'span 1',
            }}
            onChange={e => setFuzzyFilter(e.target.value)}
          /> */}
        </CriteriaRow>
        <FullHeightSizer heightOffset={180}>
          {({ height, width }) => (
            <Content style={{ height: height - 20, width }}>
              <Grid
                ref={GridRef}
                sortEnabled
                data={finalDAta}
                headers={headerWithFormatter}
                altBy={u => u.unit}
                altBgColor="#ebebeb"
                // onEditInfoChange={info => editRow(info)}
                // editInfo={editInfo}
                render={virtualizedGridRenderer({
                  rowHeaderRender,
                  height: height - 60,
                  width: width - 50,
                  cellRender: card97TableCellRender({
                    onUpdate,
                    causeCodeOmcMap,
                    CLIENT,
                  }),
                  headerRowHeight: 30,
                })}
                // fuzzyFilter={fuzzyFilter}
                isEditable={false}
                onSelectionChange={rows => {
                  selectionChange(rows)
                }}
                selectionMode="multi"
                selectionType="row"
                initialSortOptions={[
                  utilityReqHeader,
                  unitHeader,
                  { ident: 'year', sortOrder: 'asc' },
                  { ident: 'eventStart', sortOrder: 'asc' },
                  { ident: 'eventEnd', sortOrder: 'asc' },
                  // { ident: 'year', sortOrder: 'asc' },
                  { ident: 'eventNum', sortOrder: 'asc' },
                  // { ident: 'eventIdx', sortOrder: 'asc' },
                ]}
              />
            </Content>
          )}
        </FullHeightSizer>
      </div>

      <CardsErrorDialog
        keys="card97errordialog"
        errors={errorSaveData}
        closeErrorPrompt={_ => {
          setErrorSaveData([])
        }}
        action="V"
        visible={errorSaveData.length > 0}
        retrieveData={onRetrieveDataEvent}
        setShowEditDialog={_ => _}
        allowRetrieve={false}
      />
    </React.Fragment>
  )
}

// getAmpCodeMgmtInfo(apiTargetInfo).fork(setErr, d => setAmpCodeMap(ampCodeList(d)))
//  getFailCodeMgmtInfo(apiTargetInfo).fork(setErr, d => setFailCodeMap(failCodeList(d)))

export const card97TableCellRender = ({
  onView = _ => _,
  causeCodeOmcMap,
  // CLIENT = INTEG_CLIENT,
}) => params => {
  const { gridToolProps, reactVirtualizedProps } = params

  const { getCellProps, headers, data } = gridToolProps

  const { columnIndex, rowIndex, style } = reactVirtualizedProps
  // const cellProps = getCellProps({
  //   rowIndex,
  //   columnIndex,
  //   header: headers[columnIndex],
  //   data,
  //   style,
  //   ...rest,
  // })

  const cellData = extractAndFormatData({
    rowData: data[rowIndex],
    header: headers[columnIndex],
  })

  if (headers[columnIndex].ident === 'causeCode') {
    const isOmc = causeCodeOmcMap[cellData]
    let omcCellProps = getCellProps({
      rowIndex,
      columnIndex,
      header: headers[columnIndex],
      data,
      style,
    })

    omcCellProps = {
      ...omcCellProps,
      style: {
        ...style,
        backgroundColor: isOmc
          ? 'rgb(255,128,64,0.5)'
          : cellData >= 9180 && cellData <= 9199
          ? 'rgb(194,57,237,0.5)'
          : undefined,
        color:
          omcCellProps.isSelected && isOmc
            ? 'black'
            : cellData >= 9180 && cellData <= 9199
            ? 'black'
            : undefined,
      },
    }

    return (
      <VirtualizedCell
        {...R.omit(['data'], omcCellProps)}
        onDoubleClick={_ => {
          // onUpdate()
          onView()
        }}
      >
        {cellData}
      </VirtualizedCell>
    )
  }

  return defaultVirtualizedCellRender({
    ...params,
    onDoubleClick: _ => {
      // onUpdate()
      onView()
    },
  })
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
  causeCodeMap: getCauseCodeMap(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  units: getUnits(state),
  ampCodeMap: getAmlificationCode(state),
  failCodeMap: getFailCode(state),
  eventTypesData: getEventTypes(state),
  causeCodeOmcMap: getCauseCodeOmcMap(state),
})
export default connect(mapStateToProps)(Card97)

const Headers = [
  strCol({
    ident: 'utility',
    display: 'Utility',
    width: 410,
    // isKey: true,
    sortOrder: 'asc',
    ellipsis: true,
  }),
  unitHeader,
  intCol({ ident: 'year', display: 'Year', isKey: true, width: 50 }),
  intCol({
    ident: 'eventNum',
    display: 'Event Number',
    isKey: true,
    width: 80,
  }),
  intCol({ ident: 'causeCode', display: 'Cause Code', width: 80 }),
  strCol({
    ident: 'eventType',
    display: 'Event Type',
    isKey: true,
    isFiltered: true,
    width: 80,
  }),

  dateTimeCol({
    ident: 'eventStart',
    display: 'Event Start Date',
    width: 140,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'breakerStart',
    display: 'Breaker Start Date',
    width: 140,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'eventEnd',
    display: 'Event End Date',
    width: 140,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),

  dateTimeCol({
    ident: 'breakerEnd',
    display: 'Breaker End Date',
    width: 140,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  strCol({ ident: 'availCap', display: 'Available Capacity' }),
  // modifierCol,
  // modifiedDateCol,
  // strCol({ ident: 'lock', display: 'Lock' }),
].map(e => ({ ...e, isFiltered: true }))
